<template>
	<div class="floating-controls">
		<button class="floating-contact" type="button" aria-label="联系我们" @click="contactUs">
			<img class="contact-icon" :src="contactIcon" alt="">
			<span class="title">联系我们</span>
		</button>
		<button class="floating-top" type="button" aria-label="返回顶部" @click="scrollToTop">
			<img class="top-icon" :src="topIcon" alt="">
		</button>
	</div>
</template>

<script>
export default {
	name: 'FloatingContactControls',
	data() {
		return {
			contactIcon: require('@/assets/contact.png'),
			topIcon: require('@/assets/top.png'),
		}
	},
	methods: {
		contactUs() {
			this.$router.push('/caseTogether')
		},
		scrollToTop() {
			const scrollContainer = this.$el.parentElement
			if (scrollContainer) scrollContainer.scrollTop = 0
		},
	},
}
</script>

<style lang="scss" scoped>
.floating-contact,
.floating-top {
	box-sizing: border-box;
	position: fixed;
	right: 26px;
	z-index: 100;
	padding: 0;
	border: 0;
	cursor: pointer;

	&:focus-visible {
		outline: 3px solid rgba(255, 121, 91, 0.42);
		outline-offset: 3px;
	}
}

.floating-contact {
	top: 40%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 44px;
	height: 140px;
	background: linear-gradient(360deg, #FF795B 0%, #FF8E36 100%);
	box-shadow: 0 2px 10px rgba(196, 165, 145, 0.25);
	border-radius: 28px;

	.contact-icon {
		width: 16px;
		height: 16px;
	}

	.title {
		width: 16px;
		height: 80px;
		margin-top: 5px;
		font-size: 14px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #FFFFFF;
		line-height: 20px;
	}
}

.floating-top {
	top: 60%;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 48px;
	height: 48px;
	background: #FFFFFF;
	box-shadow: 0 4px 10px rgba(91, 91, 91, 0.2);
	border-radius: 50%;

	.top-icon {
		width: 16px;
		height: 16px;
	}
}
</style>
